module.exports = __webpack_public_path__ + "static/media/6.af94d2d3.png";